const Data = [
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 51,
    "peopleid": 51,
    "name": "Mitch McGovern",
    "imagename": "Mitch_McGovern",
    "club": "Carlton",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "McGovern didn't come cheap when he left a contender in Adelaide to move south instead of going home. And at this stage he hasn't justified the hype, but the Blues always believed he would eventually prove himself as a third tall alongside Charlie Curnow and Harry McKay."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 52,
    "peopleid": 52,
    "name": "Charlie Curnow",
    "imagename": "Charlie_Curnow",
    "club": "Carlton",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Signed on for four years until 2023 midway through 2018 on potential rather than output to that stage, and the injuries haven't abated since then. But every Carlton fan was thrilled to get the signature of a player on a deal worth as much as $3 million if he put up continued strong performances. Still only 77 goals and 58 games under his belt at 22."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 53,
    "peopleid": 53,
    "name": "Ben Brown",
    "imagename": "Ben_Brown",
    "club": "North Melbourne",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "The 27-year-old is awaiting the AFL green light for clubs to restart contract renewals. He had been in line for a new two or three-year deal, reportedly on $800,000 a season, with the Kangaroos before negotiations were put on hold. Brown has been a model of consistency, kicking 63, 61 and 64 goals in his past three seasons, but, like his club, he has struggled for form so far in 2020."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 54,
    "peopleid": 54,
    "name": "Rory Lobb",
    "imagename": "Rory_Lobb",
    "club": "Fremantle",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Lobb has always been well-paid, able to extract around $700,000 a season after signing a bumper contract at GWS after a breakout year as a ruck-forward. The Dockers paid up to get him home because they were determined to bolster their key position stocks, which means he is in the top handful of paid players at Freo."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 55,
    "peopleid": 55,
    "name": "Jarrod Witts",
    "imagename": "Jarrod_Witts",
    "club": "Gold Coast Suns",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "The Suns co-captain signed a five-year extension on a wage between $675,000-$725,000 a season early in 2019, capping a timely move from Collingwood to become a first-rate AFL ruckman. Low-key and rarely handed the plaudits he deserves. First he took the plunge by moving north and then he helped build the culture in his own way."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 56,
    "peopleid": 56,
    "name": "Jack Viney",
    "imagename": "Jack_Viney",
    "club": "Melbourne",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Hasn'۪t been in a rush to sign a new deal this season and it's been a smart decision. Viney's value has gone up after a tough couple of years dealing with some nightmare foot issues. The big challenge for the Demons is fitting all of their hard nuts into the midfield."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 57,
    "peopleid": 57,
    "name": "Dane Rampe",
    "imagename": "Dane_Rampe",
    "club": "Sydney Swans",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Added three seasons to his existing contract in 2018 to lock him in until 2022, Not bad for a former rookie who turned into a 2016 All-Australian. The Dogs twice sniffed around Rampe as a youngster but Sydney eventually took the plunge and have seen him turn into a player who can take almost any player who runs into his area."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 58,
    "peopleid": 58,
    "name": "Dion Prestia",
    "imagename": "Dion_Prestia",
    "club": "Richmond",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Hard to believe Prestia's five-year deal with the Tigers - signed in October 2016 - came as he sought assurances that Damien Hardwick would be retained as coach. Two flags have come since then, as well as a best-and-fairest. He will miss at least the next month - perhaps longer - with injury, but has provided exceptional value for money."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 59,
    "peopleid": 59,
    "name": "Tom McDonald",
    "imagename": "Tom_McDonald",
    "club": "Melbourne",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Timed things beautifully when he signed a four-year contract midway through a career-best 2018 season. He's a flexible key position player who had major appeal on the open market. But things haven't quite gone to plan since then, nailing 22 goals in the 20 games since his breakthrough 53-goal haul in 2018."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 60,
    "peopleid": 60,
    "name": "Charlie Cameron",
    "imagename": "Charlie_Cameron",
    "club": "Brisbane Lions",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Brisbane couldn't believe its luck when it coaxed the exciting forward north after the Adelaide Football Club implosion following its 2017 Grand Final. Now the Lions have to keep him. Cameron was on a heavily front-ended deal when he signed for four seasons - until the end of 2021 - on what Crows footy director Mark Ricciuto recently said was \"a very, very good contract.\" Cameron wants an even bigger next deal with speculation he is chasing $800-$850,000."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 61,
    "peopleid": 61,
    "name": "Michael Walters",
    "imagename": "Michael_Walters",
    "club": "Fremantle",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Definitely underpaid and under new management, which is likely to set about renegotiating a contract that goes through to 2022. An All-Australian in 2019, he is a five-time leading goalkicker at the Dockers who regularly wins matches in eye-catching style. Last year's 40.16 year was spectacular."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 62,
    "peopleid": 62,
    "name": "Taylor Adams",
    "imagename": "Taylor_Adams",
    "club": "Collingwood",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "One of many Pies to accept a long-term deal in a selfless manner so the club can remain a contender. He signed a five-year extension last July that locks him in until 2024 and the brilliant flint-hard midfielder also has the leadership skills that could eventually make him a captain in a group that also includes Jeremy Howe and Steele Sidebottom."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 63,
    "peopleid": 63,
    "name": "Zach Merrett",
    "imagename": "Zach_Merrett",
    "club": "Essendon",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Watch this space. Wouldn't be a surprise if clubs with salary cap room throw the kitchen sink at Merrett as a free agent next year. While many clubs already have some hard nut onballers, the big appeal with Merrett is his polish. Great draft pick at No.26."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 64,
    "peopleid": 64,
    "name": "Daniel Talia",
    "imagename": "Daniel_Talia",
    "club": "Adelaide",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Signed a five-year contract extension through to 2021 not long after his 2014 All-Australian season and club championship of that year. Rivals believe he is on even more money given his leverage when he signed, but as the linchpin in defence has been worth his hefty price. Not every side has a full-back that you can guarantee will terrorise the heck out of the opposition's best full-forward."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 65,
    "peopleid": 65,
    "name": "Scott Lycett",
    "imagename": "Scott_Lycett",
    "club": "Port Adelaide",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Lycett couldn't have timed his free agency better, playing only a single game due to injury in 2017 then cashing in after a 25-game premiership season at West Coast. Insiders say he is on more than the $3 million, five-year deal Port Adelaide is said to have clinched, with the Eagles receiving an end-of-first-round compo pick."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 66,
    "peopleid": 66,
    "name": "Christian Petracca",
    "imagename": "Christian_Petracca",
    "club": "Melbourne",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Has shown glimpses of his potential over the years, but this is the year Petracca makes his mark as a star midfielder. Looks fit as a fiddle and is closing the gap on Collingwood game breaker Jordan de Goey as a damaging goalkicker. Next deal could be a doozy."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 67,
    "peopleid": 67,
    "name": "Cale Hooker",
    "imagename": "Cale_Hooker",
    "club": "Essendon",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Another who secured a bumper five-year deal in 2016. At the time, Fremantle was super keen on the Western Australian to fill a missing link in defence. But Hooker remained loyal to the Bombers and is locked away until end of 2021. One more season could round out a very solid career."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 68,
    "peopleid": 68,
    "name": "Jeremy Howe",
    "imagename": "Jeremy_Howe",
    "club": "Collingwood",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "The star defender signed a three-year deal in 2018 that expires next year, with his PCL surgery poor timing given he can earn more than $700,000 with marketing money and incentives if he dominates this year. Went from Melbourne to the club he supported as a kid and now is a brilliant role model and exceptional on-field talent as well as the greatest high-flyer footy has seen."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 69,
    "peopleid": 69,
    "name": "Jade Gresham",
    "imagename": "Jade_Gresham",
    "club": "St Kilda",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Gresham signed a four-year extension at the start of 2019 through to 2023 and the money was well-earned given he has that perfect mix of darting, dangerous small forward and clearance-winning centre square expert. He pledged his future to the Saints at a time when they didn't have a lot of elite talent, but never looked like going elsewhere."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 70,
    "peopleid": 70,
    "name": "Steele Sidebottom",
    "imagename": "Steele_Sidebottom",
    "club": "Collingwood",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Sidebottom had a five-year deal expiring in 2021 that was said to pay him around $3 million but with the uptick in the salary cap would still be in the top bracket. He added an extra season through to 2022 to get more security and would have likely taken a small trim but he is still one of the stars of the compensation and deserves to be handsomely rewarded."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 71,
    "peopleid": 71,
    "name": "Jack Ziebell",
    "imagename": "Jack_Ziebell",
    "club": "North Melbourne",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Was the heir apparent to the Kangaroos' captaincy when the club locked him into a five-year extension - he already had one year left - at the end of 2015. Will be an unrestricted free agent at the end of 2021 when his current deal runs out. But Ziebell has long proclaimed he wants to be a one-club player. Has carried some nagging injuries in recent seasons, but hard to see him playing anywhere else."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 72,
    "peopleid": 72,
    "name": "Jesse Hogan",
    "imagename": "Jesse_Hogan",
    "club": "Fremantle",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Able to earn over $600,000 with strong bonuses including match payments in a strong season after taking a significant pay cut to come home to Perth. Hogan was set to earn as much as $900,000 at Melbourne with predictions he was footy's next great forward, but instead took a deal worth about $2 million over three seasons. Finally back in a good head space after mental health issues."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 73,
    "peopleid": 73,
    "name": "Brad Crouch",
    "imagename": "Brad_Crouch",
    "club": "Adelaide",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Signed a four-year deal in August 2016 after strong form as a tough ball-winning midfielder despite interest from Victoria. Comes out of contract as a free agent this year with polarising views about whether he's an elite midfielder worth $900,000 a year or just a strong accumulator who doesn't hurt the opposition enough."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 74,
    "peopleid": 74,
    "name": "Darcy Moore",
    "imagename": "Darcy_Moore",
    "club": "Collingwood",
    "salary": "$625,000-$675,000",
    "salaryCovid": "$450,000-$486,000",
    "desc": "Moore could be footy's best defender by year's end and is keen to stay at the club where his father became famous. He has missed chances to sign megabucks deals given unfortunate injuries and the Pies declining to negotiate an early contract extension after a breakout second season. But he is still well paid and, at only 24, has time to set himself up for life after football."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 75,
    "peopleid": 75,
    "name": "Lachie Hunter",
    "imagename": "Lachie_Hunter",
    "club": "Western Bulldogs",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "It's already been an expensive year for Hunter with his drink-driving incident early in the year alongside the COVID-19 reductions applied to his current deal. He signed a five-year contract just over a month from claiming the Charlie Sutton Medal in 2018. He had already signalled his intention of remaining a Bulldog for life in his acceptance speech. The deal takes him through to the end of the 2024 season."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 76,
    "peopleid": 76,
    "name": "Jake Carlisle",
    "imagename": "Jake_Carlisle",
    "club": "St Kilda",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Carlisle signed on a bumper deal when no one wanted to come to St Kilda, and while he was immediately plunged into a drugs controversy he was able to tick off the final year of his contract with a games-based trigger late last year. It means he is still on an excellent wage this year amid some speculation the club would have brokered a trade last off-season."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 77,
    "peopleid": 77,
    "name": "Josh Kennedy",
    "imagename": "Josh_Kennedy",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Kennedy signed a significant three-year deal in late 2016 as one of the game's most relentless and durable footballers. Has now had that deal extended through to 2021 after Sydney pulled off one of footy's most remarkable recruiting heists. He turned himself from a fringe Hawk into a player who peeled off top-three best-and-fairest results year after year after year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 78,
    "peopleid": 78,
    "name": "James Sicily",
    "imagename": "James_Sicily",
    "club": "Hawthorn",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Looks cheap for one of the most damaging playmakers in the competition. Sicily was a strong contender for All-Australian selection in each of the past two seasons and is a weapon using the ball off the back flank. The gun interceptor has matured in recent seasons and will remain at the club until the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 79,
    "peopleid": 79,
    "name": "Sam Docherty",
    "imagename": "Sam_Docherty",
    "club": "Carlton",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Blues co-captain added an extra season to his deal in 2019 having shown he is among footy's best defenders before having to rehabilitate a ruptured ACL twice. One of footy's best thinkers and media performers, you get the feeling he will go straight into coaching when his career finishes, having started that process by helping from the sidelines as he worked on his return to AFL."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 80,
    "peopleid": 80,
    "name": "Phil Davis",
    "imagename": "Phil_Davis",
    "club": "GWS Giants",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Probably has one more season in him after signing his latest three-year deal in 2018. Davis, 29, has earned good money at GWS since departing Adelaide on a godfather deal. Has been a key leader in a defensive role since the Giants' first years."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 81,
    "peopleid": 81,
    "name": "Peter Wright",
    "imagename": "Peter_Wright",
    "club": "Gold Coast Suns",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Wright signed a lucrative extension through to 2022 last year but is yet to match the hype, with \"Two Metre Peter\" out of the team this year after 21 goals in 17 games last season. His salary is reflective of the difficulty in finding 200cm key-forward rucks in the AFL. With Jarrod Witts thriving with big game time as a ruckman and Sam Day the current foil to Ben King, Wright hasn't cracked it for a senior game yet this year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 82,
    "peopleid": 82,
    "name": "Brandon Ellis",
    "imagename": "Brandon_Ellis",
    "club": "Gold Coast Suns",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Richmond premiership player signed a five-season deal believed to be just over $600,000 a season last year to add quality ball use and hard run to a young Suns' side. So far it's exactly what he has done even if he has been solid rather than eye-catching. Ellis made an easy call to move on from the Tigers to shore up his family's financial future."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 83,
    "peopleid": 83,
    "name": "Isaac Smith",
    "imagename": "Isaac_Smith",
    "club": "Hawthorn",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Bulldogs unsuccessfully chased Smith last year in a bid to add some more cream to a stacked midfield. He is a restricted free agent at Hawthorn and will surely attract more offers at season's end as the club weighs up a move to top-up again or chase more top-end talent in the draft."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 84,
    "peopleid": 84,
    "name": "Dayne Zorko",
    "imagename": "Dayne_Zorko",
    "club": "Brisbane Lions",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "A contract extension signed by the Brisbane skipper in early 2019 locked him in until the end of 2021. That upped the ante after he had previously signed a $2 million five-year deal, which was upgraded after four successive best-and-fairest awards. The Lions pay many of their stars with an excellent base component with bonus clauses."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 85,
    "peopleid": 85,
    "name": "Tom Papley",
    "imagename": "Tom_Papley",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Gippsland boy is tied to the Swans all the way through to 2023, having signed a deal in 2018 that included a trigger clause he quickly ticked off. It means he is well paid for his services after wanting to be traded to Carlton last year. So he should be, as one of footy's best-performed small forwards. Still weighing his future."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 86,
    "peopleid": 86,
    "name": "Angus Brayshaw",
    "imagename": "Angus_Brayshaw",
    "club": "Melbourne",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "North Melbourne went extremely hard at Brayshaw, making Melbourne plump up its offer in a bid to keep the tough nut ball-winner. He finished third in the Brownlow Medal in 2018 but he had a difficult year last season, playing outside the centre square. Contracted until the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 87,
    "peopleid": 87,
    "name": "Dan Hannebery",
    "imagename": "Dan_Hannebery",
    "club": "St Kilda",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "St Kilda has long been aggrieved at reports on the scope of Hannebery's contract, a four-year deal with triggers for a fifth season. Instead of earning him up to $800,000 a season, his deal is less than $700,000, still a rich reward but fairer compensation for a player who represented a risk given his groin and soft-tissue concerns of recent years."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 88,
    "peopleid": 88,
    "name": "Callum Mills",
    "imagename": "Callum_Mills",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Just months after locking away Isaac Heeney in early 2017, the Swans secured a five-year contract extension for Mills, fresh off his Rising Star win. The massive show of faith came after Mills' exceptional debut season. The deal locks him into the club he barracked for as a kid until the end of 2023, when he will still only be 26 years of age."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 89,
    "peopleid": 89,
    "name": "Jack Gunston",
    "imagename": "Jack_Gunston",
    "club": "Hawthorn",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Hawks moved early to sign Gunston in late 2018 well before he was due to come out in 2019. That's how the Hawks operate with their most important players to ensure they aren't vulnerable to a poaching raid. It's smart and the improved deal rewarded Gunston for his continued excellent service at both ends of the ground."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 90,
    "peopleid": 90,
    "name": "Nic Naitanui",
    "imagename": "Nic_Naitanui",
    "club": "West Coast",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "At times Naitanui has been one of footy's highest-earning players. And make no mistake, he is effectively the king of Perth with his extraordinary reach as an ambassador, marketing force and A-Grade celebrity in a state where footy couldn't be bigger. Instead of a seven-figure salary, he took a pay cut when he re-signed only days before a return from a knee reconstruction in 2019 that locks him away until 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 91,
    "peopleid": 91,
    "name": "Stephen Coniglio",
    "imagename": "Stephen_Coniglio",
    "club": "GWS Giants",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The new GWS captain has taken a back-ended deal like many of his teammates to keep the list together, happy to sign on for a seven-year deal despite coming perilously close to moving to Carlton. The average is much higher but while the Giants are in the sweet spot everyone is sacrificing to keep the list in shape."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 92,
    "peopleid": 92,
    "name": "Jason Johannisen",
    "imagename": "Jason_Johannisen",
    "club": "Western Bulldogs",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Norm Smith medallist Jason Johannisen weighed up several lucrative offers from rival clubs in mid-2017 before locking into a five-year-deal with the Bulldogs, believed to be worth around $600,000 per season. The deal locked him into the club until the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 93,
    "peopleid": 93,
    "name": "Dougal Howard",
    "imagename": "Dougal_Howard",
    "club": "St Kilda",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Howard signed a five-year deal with the Saints on $600,000 a season after the swingman fell out of favour at Port Adelaide. While he hasn't set the world on fire yet at the Saints, he has been a solid defensive presence."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 94,
    "peopleid": 94,
    "name": "Easton Wood",
    "imagename": "Easton_Wood",
    "club": "Western Bulldogs",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "One of footy's best interceptors at his best, he signed his deal not long after the Dogs' premiership heroics as the captain and attacking force off half-back. Wood has had injury worries of late but signed his deal at the perfect time to maximise his worth and handed the captaincy over to Marcus Bontempelli with the club in excellent shape."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 95,
    "peopleid": 95,
    "name": "Jake Lloyd",
    "imagename": "Jake_Lloyd",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Lloyd signed a four-year deal off the back of a season that had him in the All-Australian 40 and chased hard by Gold Coast keen on his bounce from defence and long precise kicking. That September 2018 deal has him locked away until 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 96,
    "peopleid": 96,
    "name": "Charlie Dixon",
    "imagename": "Charlie_Dixon",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "The ex-Sun was able to use Adelaide's interest to secure a five-year deal on $600,000 when he arrived at Port Adelaide on a contract that expires this year. He will get well paid once again. The big key forwards get the big dollars and Dixon is no different."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 97,
    "peopleid": 97,
    "name": "Hamish Hartlett",
    "imagename": "Hamish_Hartlett",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "Hartlett had maximum leverage when he signed a five-year deal with the Power in 2015 as clubs including Richmond and North Melbourne showed interest. Hasn't reached the heights he might have wanted but has few regrets even as he passed up the Tigers' interest. Out of contract in 2021."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 98,
    "peopleid": 98,
    "name": "Tom Rockliff",
    "imagename": "Tom_Rockliff",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "The Power snapped up out ex-Brisbane captain Rockliff as part of a late 2017 recruiting spree and paid a significant price for the free agent. The deal is believed to be just on $575,000 a season over a four-year deal for the clearance king, but the club's welter of young midfielders are making life hard. Has been dropped this year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 99,
    "peopleid": 99,
    "name": "Tom Jonas",
    "imagename": "Tom_Jonas",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "Jonas has graduated from one-time rookie to the sole captain of Port Adelaide after sharing the role with Ollie Wines last year. The 29-year-old defender recommitted to the club at the end of the 2018 season when he still had one year remaining. His current contract runs through to the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 100,
    "peopleid": 100,
    "name": "Brodie Grundy",
    "imagename": "Brodie_Grundy",
    "club": "Collingwood",
    "salary": "$550,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "The AFL's prototypical ruckman drove a hard bargain and even threatened to head home but eventually got his seven-year contract extension. He secured it for a tick under $7 million but, like Tom Lynch, will make just under $600,000 this season before his contract ramps up in 2021."
  }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js